<template>
    <div class="c-dynamic-list">

        <slot slot="beforeSearchForm"></slot>

        <SearchForm
                v-if="dataSearchFormStructure.rows !== undefined"
                ref="searchForm"
                caption="Recherche"
                @onSubmit="search"
                @onReset="reset"
                :structure="dataSearchFormStructure">
        </SearchForm>

        <slot name="afterSearchForm"></slot>
        <Request
                ref="request"
                :onRequestSuccess="requestSuccess"
                :onRequestError="requestError"
                :root="root">
            <slot slot="body">

                <slot slot="beforeList"></slot>

                <div>
                    <List
                            ref="list"
                            :caption="caption"
                            :subCaption="subCaption"
                            :options="options"
                            :onColumnClick="sort"
                            :onPageClick="page"
                            :selectOptions="dataSelectOptions"
                            :pagination="dataPagination"
                            :columns="dataColumns"
                            :rows="dataRows">
                    </List>
                </div>

                <slot name="afterList">
                </slot>

            </slot>
        </Request>
    </div>
</template>
<script>
    import List from './List'
    import Request from './Request'
    import SearchForm from './SearchForm'

    export default {
        name: 'DynamicList',
        components: {
            List,
            Request,
            SearchForm
        },
        props: {
            retrieveOnMount: {
                type: Boolean,
                default: true
            },
            caption: {
                type: String,
                default: ''
            },
            subCaption: {
                type: String,
                default: ''
            },
            root: {
                type: String,
                default: ''
            },
            add: {
                type: Object,
                default: function () {
                    return {
                        show: false,
                        text: '',
                        onClick: function () {}
                    }
                }
            },
            trash: {
                type: Object,
                default: function () {
                    return {
                        show: false,
                        text: '',
                        onClick: function () {}
                    }
                }
            },
            edit: {
                type: Object,
                default: function () {
                    return {
                        show: false,
                        text: '',
                        onClick: function () {}
                    }
                }
            },
            duplicate: {
                type: Object,
                default: function () {
                    return {
                        show: false,
                        text: '',
                        onClick: function () {}
                    }
                }
            },
            searchFormStructure: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            columns: {
                type: Array,
                default: function () {
                    return []
                }
            },
            options: {
                type: Object,
                default: function () {
                    return {
                        pagination: true,
                        header: true,
                        responsive: false,
                        striped: true,
                        headerStyle: '1',
                        emptyText: 'Aucun résultat',
                        borderVariant: '',
                        noBody: false
                    }
                }
            },
            onRetrieve: {
                type: Function,
                default: function () {
                    return false
                }
            },
            searchArgs: {
                type: Array,
                default: function () {
                    return []
                }
            },
            actions: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        watch: {
            searchArgs(val) {
                this.dataSearchArgs = val
            },
            searchFormStructure: {
                handler(val) {
                    this.dataSearchFormStructure = val
                },
                deep: true
            }
        },
        beforeMount() {
            this.dataColumns = this.columns
        },
        mounted() {
            this.dataSearchArgs = this.searchArgs
            this.dataSearchFormStructure = this.searchFormStructure
            this.addActions(this.actions)
            if (this.retrieveOnMount===true) {
                this.retrieve()
            }
        },
        beforeDestroy() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataColumns: [],
                dataRows: [],
                dataSearchFormStructure: {},
                dataPagination: {
                    totalRows: 0,
                    perPage: 10,
                    page: 1,
                    prevText: 'Préc.',
                    nextText: 'Suiv.'
                },
                dataForm: {},
                dataSearchArgs: [],
                dataSelectOptions: {}
            }
        },
        methods: {
            addActions(actions) {

                for(let action in actions) {
                    action = actions[action]
                    this.$refs.list.addAction(action.key, action.callBack, action.columnLabel, action.value, action.columnClass, action.columnStyles)
                }

                if (this.edit.show && this.edit.onClick !== undefined) {
                    this.$refs.list.addAction('edit', this.edit.onClick, '', this.edit.text, '', 'width:20px')
                }
                if (this.trash.show && this.trash.onClick !== undefined) {
                    this.$refs.list.addAction('trash', this.trash.onClick, '', this.trash.text, '', 'width:20px')
                }
                if (this.duplicate.show && this.duplicate.onClick !== undefined) {
                    this.$refs.list.addAction('duplicate', this.duplicate.onClick, '', this.duplicate.text, '', 'width:20px')
                }
            },
            retrieve() {
                this.onRetrieve()

                this.$emit('onRetrieve')

                let search = []
                let searchArg = this.$refs.request.getArg('search')
                if (searchArg !== false && searchArg.value !== undefined) {
                    search = searchArg.value
                }

                for(let searchArg in this.dataSearchArgs) {
                    searchArg = this.dataSearchArgs[searchArg]
                    let arg = {key: searchArg.key, value: searchArg.value}
                    if (searchArg.compare !== undefined) {
                        arg.compare = searchArg.compare
                    }
                    let findIndex = Core.Array.findByKey(search, 'key', searchArg.key)
                    if (findIndex) {
                        search[findIndex] = arg
                    } else {
                        search.push(arg)
                    }
                }
                this.$refs.request.addArg('search', search, Core.Value.typeJSON)

                this.$refs.request.request()
            },
            reset() {
                this.$refs.request.clearArgs()
                this.retrieve()
            },
            search(form, fieldRefs, structure) {
                let search = []

                if (structure.fields !== undefined) {
                    for (let field in structure.fields) {
                        field = structure.fields[field]
                        let value = form[field.id]
                        if (value !== ''&&value!==undefined&&value!==null) {
                            value = window.Core.Value.decode(value, field.type)
                            let arg = {key: field.id, value: value}
                            if (field.compare !== undefined) {
                                arg.compare = field.compare
                            }
                            search.push(arg)
                        }
                    }
                }
                this.$refs.request.addArg('search', search, Core.Value.typeJSON)
                this.retrieve()
            },
            sort(column, index) {
                if (column.sortable === true) {
                    let sortableKey = column.key
                    if (column.sortableKey !== undefined) {
                        sortableKey = column.sortableKey
                    }
                    let postArgs = this.$refs.request.dataArgs
                    let postArgIndex = window.Core.Array.findIndexByKey(postArgs, 'sortBy', sortableKey)
                    if (postArgIndex !== false) {
                        this.$refs.request.addArg('sortDirection', 'DESC')
                    } else {
                        this.$refs.request.addArg('sortDirection', 'ASC')
                    }
                    this.$refs.request.addArg('sortBy', sortableKey)
                    this.retrieve()
                }
            },
            page(page) {
                this.$refs.request.addArg('page', page)
                this.retrieve()
            },
            requestSuccess(data) {
                if (undefined !== data.columns) {
                    this.dataColumns = data.columns
                }
                if (undefined !== data.rows) {
                    this.dataRows = data.rows
                }
                if (undefined !== data.searchFormStructure) {
                    this.dataSearchFormStructure = data.searchFormStructure
                }
                if (undefined !== data.pagination) {
                    this.dataPagination = data.pagination
                }
                if (undefined !== data.selectOptions) {
                    this.dataSelectOptions = data.selectOptions
                    this.setSelectOptions(data.selectOptions)
                }
                this.onRetrieve(data)
            },
            requestError(data) {
            },
            setSelectOptions(selectOptions) {
                let searchFormFieldRefs = this.$refs.searchForm.getFormFieldRefs()
                for(let optionKey in selectOptions) {
                    for(let fieldRefKey in searchFormFieldRefs) {
                        if(optionKey === fieldRefKey) {
                            searchFormFieldRefs[fieldRefKey].setOptions(selectOptions[optionKey])
                        }
                    }
                }
            }
        }
    }
</script>

